import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { Markup } from 'interweave';

function ErrorMessage({
  errorInitialState = { code: null, message: null },
  errorMessage,
  setError,
  style,
  timeout
}) {
  useEffect(() => {
    if (timeout) {
      let timer;
      if (errorMessage) {
        timer = setTimeout(() => setError(errorInitialState), timeout);
      }
      return () => timer && clearTimeout(timer);
    }
  }, [errorMessage]);

  return (
    <AnimatePresence>
      {errorMessage && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{
            color: 'var(--blue)',
            textAlign: 'center',
            ...style
          }}>
          <Markup content={errorMessage} noWrap />
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ErrorMessage;
